import { useMutation, useQuery, useQueryClient } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchAgencyNotifications, resendAgencyNotification, } from "../api/agencyNotificationService";
import { agencyNotificationsQueryKey, } from "../types/agencyNotification";
export var useAgencyNotifications = function (titleId) {
    var kyInstance = useOkapiKy();
    var _a = useQuery(agencyNotificationsQueryKey(titleId), function () { return fetchAgencyNotifications(kyInstance, titleId); }, { enabled: !!titleId }), _b = _a.data, notifications = _b === void 0 ? [] : _b, isLoading = _a.isLoading, isError = _a.isError;
    return {
        notifications: notifications,
        isNotificationsLoading: isLoading,
        isNotificationsError: isError,
    };
};
export var useResendAgencyNotification = function (onResent) {
    var kyInstance = useOkapiKy();
    var queryClient = useQueryClient();
    return useMutation(function (_a) {
        var titleId = _a.titleId, notificationId = _a.notificationId;
        return resendAgencyNotification(kyInstance, titleId, notificationId);
    }, {
        onSettled: function (_result, _error, _a) {
            var titleId = _a.titleId;
            queryClient.invalidateQueries(agencyNotificationsQueryKey(titleId));
        },
        onSuccess: function (notification) {
            onResent === null || onResent === void 0 ? void 0 : onResent(notification);
        },
    });
};
